import ApplicationView from './common/ApplicationView';
//import CesiumHandler from '/js/components/CesiumHandler';

import { ResourceContainer } from 'ohzi-core';

/**
 * @class MenuOptionsView
 * @description This class is responsible for the pop up menu that appears when we are clicking the options button.
 * menu_options.pug is the template that is connected.
 */

// This represents the menu panel that contains the live and recordings section.
export default class MenuOptionsView extends ApplicationView
{
  constructor(app)
  {
    super('menu__options', $('.menu__options'));

    this.app = app;

    this.is_opened = false;

    this.thumbnail_types = {
      VIDEO: 'video',
      IMAGE: 'image',
      OFF: 'off'
    };

    this.active_tgt_types = {
      JSON: 'json',
      NMEA: 'nmea',
      OFF: 'off'
    };

    this.keep_menu_visible = (localStorage.getItem('keep_menu_visible') === 'true') || false;

    let internal_show_diagnostic_messages = localStorage.getItem('show_diagnostic_messages');
    this.show_diagnostic_messages = internal_show_diagnostic_messages === null ? true : (internal_show_diagnostic_messages === 'true');

    let internal_show_thumbnail_video = localStorage.getItem('show_thumbnail_video');
    // On C2 default to image and Standalone Player default to video
    let show_thumbnail_video_default = this.app.mode_multi_camera ? false : true;
    this.show_thumbnail_video = internal_show_thumbnail_video === null ? show_thumbnail_video_default : (internal_show_thumbnail_video === 'true');

    let internal_show_thumbnail_image = localStorage.getItem('show_thumbnail_image');
    //this.show_thumbnail_image = (localStorage.getItem('show_thumbnail_image') === 'true') || false;
    this.show_thumbnail_image = internal_show_thumbnail_image === null ? !show_thumbnail_video_default : (internal_show_thumbnail_image === 'true');

    this.active_tgt_json = false;
    this.active_tgt_nmea = false;

    let internal_show_cesium_buildings = localStorage.getItem('show_cesium_buildings');
    this.show_cesium_buildings = internal_show_cesium_buildings === null ? false : (internal_show_cesium_buildings === 'true');

    let internal_launch_full_screen = localStorage.getItem('launch_full_screen');
    this.launch_full_screen = internal_launch_full_screen === null ? false : (internal_launch_full_screen === 'true');
    //PlayerSettings.launch_full_screen = this.launch_full_screen;

    let internal_c2_launch_standalone = localStorage.getItem('c2_launch_standalone');
    this.c2_launch_standalone = internal_c2_launch_standalone === null ? false : (internal_c2_launch_standalone === 'true');
    //PlayerSettings.c2_launch_standalone = this.c2_launch_standalone;

    let internal_c2_show_camera_names = localStorage.getItem('c2_show_camera_names');
    this.c2_show_camera_names = internal_c2_show_camera_names === null ? true : (internal_c2_show_camera_names === 'true');
    //PlayerSettings.c2_show_camera_names = this.c2_show_camera_names;

    let internal_hide_taglock_tracks = localStorage.getItem('hide_taglock_tracks');
    this.hide_taglock_tracks = internal_hide_taglock_tracks === null ? false : (internal_hide_taglock_tracks === 'true');
    //PlayerSettings.hide_taglock_tracks = this.hide_taglock_tracks;

    let internal_show_notifications = localStorage.getItem('show_notifications');
    this.show_notifications = internal_show_notifications === null ? true : (internal_show_notifications === 'true');
    //NotificationManager.show_notifications = this.show_notifications;

    let internal_enable_notification_sound = localStorage.getItem('enable_notification_sound');
    this.enable_notification_sound = internal_enable_notification_sound === null ? true : (internal_enable_notification_sound === 'true');
    //NotificationManager.enable_notification_sound = this.enable_notification_sound;

    let app_config = ResourceContainer.get_resource('config');

    this.ai_enable = true;

    let internal_c2_ai_stream_all = localStorage.getItem('c2_ai_stream_all');
    this.c2_ai_stream_all = internal_c2_ai_stream_all === null ? false : (internal_c2_ai_stream_all === 'true');
    //PlayerSettings.c2_ai_stream_all = this.c2_ai_stream_all;

  }

  start()
  {
    this.menu_options_container = $('.menu__options-container');
    this.menu_options_button = $('.menu__buttons-options');

    this.menu_options_item_menu_visible = document.querySelector('.menu__options-item--menu-visible');
    this.menu_options_item_diagnostic_messages = document.querySelector('.menu__options-item--diagnostic-messages');
    this.menu_options_item_cesium_buildings = document.querySelector('.menu__options-item--cesium-buildings');
    this.menu_options_item_thumbnail_video = document.querySelector('.menu__options-item--thumbnail-video');
    this.menu_options_item_thumbnail_image = document.querySelector('.menu__options-item--thumbnail-image');
    this.menu_options_item_thumbnail_off = document.querySelector('.menu__options-item--thumbnail-off');
    this.menu_options_item_active_tgt_json = document.querySelector('.menu__options-item--active-tgt-json');
    this.menu_options_item_active_tgt_off = document.querySelector('.menu__options-item--active-tgt-off');

    this.menu_options_item_launch_full_screen = document.querySelector('.menu__options-item--launch-full-screen');
    this.menu_options_item_c2_launch_standalone = document.querySelector('.menu__options-item--c2-launch-standalone');
    this.menu_options_item_c2_show_camera_names = document.querySelector('.menu__options-item--c2-show-camera-map-names');
    this.menu_options_item_hide_taglock_tracks = document.querySelector('.menu__options-item--hide-taglock-tracks');
    this.menu_options_item_show_notifications = document.querySelector('.menu__options-item--show-notifications');
    this.menu_options_item_enable_notification_sound = document.querySelector('.menu__options-item--enable-notification-sound');
    this.menu_options_item_ai_enable = document.querySelector('.menu__options-item--ai-enable');
    this.menu_options_item_c2_ai_stream_all = document.querySelector('.menu__options-item--c2-ai-stream-all');
    
    this.__toggle_switch_elem(this.menu_options_item_menu_visible, this.keep_menu_visible);
    this.__toggle_switch_elem(this.menu_options_item_diagnostic_messages, this.show_diagnostic_messages);
    this.__toggle_switch_elem(this.menu_options_item_cesium_buildings, this.show_cesium_buildings);
    this.__toggle_switch_elem(this.menu_options_item_thumbnail_video, this.show_thumbnail_video);
    this.__toggle_switch_elem(this.menu_options_item_thumbnail_image, this.show_thumbnail_image);
    this.__toggle_switch_elem(this.menu_options_item_thumbnail_off, (!this.show_thumbnail_image && !this.show_thumbnail_video));

    this.__toggle_switch_elem(this.menu_options_item_active_tgt_json, this.active_tgt_json);
    this.__toggle_switch_elem(this.menu_options_item_active_tgt_off, (!this.active_tgt_json && !this.active_tgt_nmea));
    this.__toggle_switch_elem(this.menu_options_item_ai_enable, this.ai_enable);
    this.__toggle_switch_elem(this.menu_options_item_c2_ai_stream_all, this.c2_ai_stream_all);

    this.__toggle_switch_elem(this.menu_options_item_launch_full_screen, this.launch_full_screen);
    this.__toggle_switch_elem(this.menu_options_item_c2_launch_standalone, this.c2_launch_standalone);
    this.__toggle_switch_elem(this.menu_options_item_c2_show_camera_names, this.c2_show_camera_names);
    this.__toggle_switch_elem(this.menu_options_item_hide_taglock_tracks, this.hide_taglock_tracks);
    this.__toggle_switch_elem(this.menu_options_item_show_notifications, this.show_notifications);
    this.__toggle_switch_elem(this.menu_options_item_enable_notification_sound, this.enable_notification_sound);

    // Do other actions here

    this.click_event = window.addEventListener('mousedown', this.__on_container_click.bind(this));
    this.menu_options_container[0].addEventListener('mousedown', this.__on_menu_options_container_click.bind(this));

    if (this.show_cesium_buildings)
    {
      CesiumHandler.enable_osm_buildings();
    }
  }

  show()
  {
    super.show();

    this.menu_options_button.addClass('active');
    this.is_opened = true;
  }

  hide()
  {
    super.hide();

    this.menu_options_button.removeClass('active');
    this.is_opened = false;
  }

  // Called by the UI (menu_options.pug) when the user clicks on the menu visible toggle
  toggle_menu_visible()
  {
    this.keep_menu_visible = !this.keep_menu_visible;

    this.__toggle_switch_elem(this.menu_options_item_menu_visible, this.keep_menu_visible);

    localStorage.setItem('keep_menu_visible', this.keep_menu_visible);
  }

  // Called by the UI (menu_options.pug) when the user clicks on the diagnostic messages toggle
  toggle_diagnostic_messages()
  {
    this.show_diagnostic_messages = !this.show_diagnostic_messages;

    this.__toggle_switch_elem(this.menu_options_item_diagnostic_messages, this.show_diagnostic_messages);

    localStorage.setItem('show_diagnostic_messages', this.show_diagnostic_messages);
  }

  // Called by the UI (menu_options.pug) when the user clicks on the launch full screen toggle
  toggle_launch_full_screen()
  {
    this.launch_full_screen = !this.launch_full_screen;

    // Mirror setting to PlayerSettings to access from camera instances
    //PlayerSettings.launch_full_screen = this.launch_full_screen;

    this.__toggle_switch_elem(this.menu_options_item_launch_full_screen, this.launch_full_screen);

    localStorage.setItem('launch_full_screen', this.launch_full_screen);
  }

  // Called by the UI (menu_options_c2.pug) when the user clicks on the launch standalone toggle
  toggle_c2_launch_standalone()
  {
    this.c2_launch_standalone = !this.c2_launch_standalone;

    // Mirror setting to PlayerSettings to access from camera instances
    //PlayerSettings.c2_launch_standalone = this.c2_launch_standalone;

    this.__toggle_switch_elem(this.menu_options_item_c2_launch_standalone, this.c2_launch_standalone);

    localStorage.setItem('c2_launch_standalone', this.c2_launch_standalone);
  }

  toggle_c2_show_camera_names()
  {
    this.c2_show_camera_names = !this.c2_show_camera_names;

    this.__toggle_switch_elem(this.menu_options_item_c2_show_camera_names, this.c2_show_camera_names);

    localStorage.setItem('c2_show_camera_names', this.c2_show_camera_names);

    // Do other actions here
  }


  // Called by the UI (menu_options_c2.pug) when the user clicks on the hide taglock tracks toggle
  toggle_hide_taglock_tracks()
  {
    this.hide_taglock_tracks = !this.hide_taglock_tracks;

    // Mirror setting to PlayerSettings to access from camera instances
    //PlayerSettings.hide_taglock_tracks = this.hide_taglock_tracks;

    this.__toggle_switch_elem(this.menu_options_item_hide_taglock_tracks, this.hide_taglock_tracks);

    localStorage.setItem('hide_taglock_tracks', this.hide_taglock_tracks);

    if (this.hide_taglock_tracks)
    {
      //
    }
    else
    {
      //
    }
  }

  // Called by the UI (menu_options.pug) when the user clicks on the show notifications toggle
  toggle_show_notifications()
  {
    this.show_notifications = !this.show_notifications;

    // Mirror setting to NotificationManager
    //NotificationManager.show_notifications = this.show_notifications;

    this.__toggle_switch_elem(this.menu_options_item_show_notifications, this.show_notifications);

    localStorage.setItem('show_notifications', this.show_notifications);
  }

  // Called by the UI (menu_options.pug) when the user clicks on the enable notification sounds toggle
  toggle_enable_notification_sound()
  {

    this.enable_notification_sound = !this.enable_notification_sound;

    // Mirror setting to NotificationManager
    //NotificationManager.enable_notification_sound = this.enable_notification_sound;

    this.__toggle_switch_elem(this.menu_options_item_enable_notification_sound, this.enable_notification_sound);

    localStorage.setItem('enable_notification_sound', this.enable_notification_sound);
  }

  // Called by the UI (menu_options.pug) when the user clicks on the Active TGT toggle
  toggle_active_tgt(type)
  {
    // Do other actions here

    this.__toggle_switch_elem(this.menu_options_item_active_tgt_json, this.active_tgt_json);
    this.__toggle_switch_elem(this.menu_options_item_active_tgt_off, (!this.active_tgt_json && !this.active_tgt_nmea));
  }

  // Called by the UI (menu_options.pug) when the user clicks on the thumbnail video toggle
  toggle_thumbnail(type)
  {
    switch (type)
    {
    case this.thumbnail_types.VIDEO:
      this.show_thumbnail_image = false;
      this.show_thumbnail_video = true;
      break;
    case this.thumbnail_types.IMAGE:
      this.show_thumbnail_image = true;
      this.show_thumbnail_video = false;
      break;
    case this.thumbnail_types.OFF:
      this.show_thumbnail_image = false;
      this.show_thumbnail_video = false;
      break;
    }

    this.__toggle_switch_elem(this.menu_options_item_thumbnail_video, this.show_thumbnail_video);
    this.__toggle_switch_elem(this.menu_options_item_thumbnail_image, this.show_thumbnail_image);
    this.__toggle_switch_elem(this.menu_options_item_thumbnail_off, (!this.show_thumbnail_image && !this.show_thumbnail_video));

    // Do other actions here

    localStorage.setItem('show_thumbnail_image', this.show_thumbnail_image);
    localStorage.setItem('show_thumbnail_video', this.show_thumbnail_video);
  }

  // Called by the UI (menu_options.pug) when the user clicks on the cesium OSM buildings toggle
  toggle_cesium_buildings()
  {
    this.show_cesium_buildings = !this.show_cesium_buildings;

    this.__toggle_switch_elem(this.menu_options_item_cesium_buildings, this.show_cesium_buildings);

    if (this.show_cesium_buildings)
    {
      CesiumHandler.enable_osm_buildings();
    }
    else
    {
      CesiumHandler.disable_osm_buildings();
    }

    localStorage.setItem('show_cesium_buildings', this.show_cesium_buildings);
  }

  // Called by the UI (menu_options.pug) when the user clicks on the 'AI Enable' toggle
  toggle_ai_enable()
  {
    this.ai_enable = !this.ai_enable;

    this.__toggle_switch_elem(this.menu_options_item_ai_enable, this.ai_enable);

    // Do other actions here
  
    localStorage.setItem('ai_enable', this.ai_enable);
  }

  // Called by the UI (menu_options.pug) when the user clicks on the 'AI Stream All' toggle
  toggle_c2_ai_stream_all()
  {
    this.c2_ai_stream_all = !this.c2_ai_stream_all;

    this.__toggle_switch_elem(this.menu_options_item_c2_ai_stream_all, this.c2_ai_stream_all);

    // Do other actions here
  
    localStorage.setItem('c2_ai_stream_all', this.c2_ai_stream_all);
  }

  // Called by the UI (menu_options.pug) when the user changes the Cesium Token field
  on_cesium_token(value)
  {
    console.log('[on_cesium_token]');
    // Do other actions here

    localStorage.setItem('cesium_token', this.menu_options_item_cesium_token.value);
  }

  __toggle_switch_elem(elem, should_activate)
  {
    if (should_activate)
    {
      $(elem).addClass('active');
    }
    else
    {
      $(elem).removeClass('active');
    }
  }

  __on_container_click()
  {
    if (this.is_opened)
    {
      this.hide();
    }
  }

  __on_menu_options_container_click(event)
  {
    event.stopImmediatePropagation();
  }
}
